import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
import indexRoutes from "./routes/index.jsx";
import {BackForAppConfiguration} from './configurations/ParseConfiguration';
import { isMoment } from "moment";
import Parse from 'parse';


import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.1.1";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";


Parse.serverURL = BackForAppConfiguration.ServerUrl;
Parse.initialize(BackForAppConfiguration.ApplicationId, BackForAppConfiguration.JavascriptKey);




ReactDOM.render(
  <HashRouter>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} component={prop.component} key={key} />;
      })}
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js